const getSearchParam = (paramsString: string, searchKey: string) => {
	if (!paramsString || !searchKey) {
		return '';
	}
	const searchParams = new URLSearchParams(paramsString);
	return searchParams.get(searchKey);
};

export { getSearchParam };
